import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import CheckBox from '../../components/Inputs/CheckBox/CheckBox';
import { isBlankHelperText } from '../../helper/ValidationHelper';
import EnumService from '../../services/Enum';

import Toast from '../../components/Toast/Toast';

import { FormGroup, FormControl, FormLabel } from '@material-ui/core';

export class AnosLetivos extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            anosLetivosSelecionados: [],
            optionsAnosLetivos: [],
            errors: {
                anosLetivos: false,
            },
            helpers: {
                anosLetivos: null,
            },

        }
    }

    // INPUTS
    handleCheckboxChange = (value) => {
        const { anosLetivosSelecionados } = this.state;

        if (anosLetivosSelecionados.includes(value)) {
            const novosSelecionados = anosLetivosSelecionados.filter(v => v !== value);

            this.setState({
                anosLetivosSelecionados: novosSelecionados,
                errors: {
                    ...this.state.errors,
                    anosLetivos: novosSelecionados.length === 0
                },
                helpers: {
                    ...this.state.helpers,
                    anosLetivos: novosSelecionados.length === 0 ? isBlankHelperText() : null
                }
            });

        } else {
            const novosSelecionados = [...anosLetivosSelecionados, value];

            this.setState({
                anosLetivosSelecionados: novosSelecionados,
                errors: {
                    ...this.state.errors,
                    anosLetivos: novosSelecionados.length === 0
                },
                helpers: {
                    ...this.state.helpers,
                    anosLetivos: novosSelecionados.length === 0 ? isBlankHelperText() : null
                }
            });
        }
    };

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;

    // VALIDAÇÕES
    isValid = () => {
        const anoLetivoBlank = this.state.anosLetivosSelecionados.length === 0;

        if (anoLetivoBlank) {
            this.setState({
                errors: {
                    anosLetivos: anoLetivoBlank,
                },
                helpers: {
                    anosLetivos: anoLetivoBlank ? isBlankHelperText() : null,
                },
            });
            return false;
        }
        return true;
    }

    async componentDidMount() {
        const anosLetivos = await EnumService.listarAnosLetivos().then(res => res.data);
        this.setState({ optionsAnosLetivos: anosLetivos, });
    }

    render() {

        const { disabled } = this.props;

        return (
            <>
                <Toast parentRef={this.setToast} />
                <Grid container spacing={3}>
                    <Grid item sm={12} lg={12}>
                        <FormControl disabled={this.props.disabled} error={this.state.errors.anosLetivos} component="fieldset">

                            <FormLabel component="legend">
                                Anos Letivos *
                            </FormLabel>

                            <FormGroup row>
                                {this.state.optionsAnosLetivos.map(option => {
                                    const selecionado = this.state.anosLetivosSelecionados.includes(option.value);

                                    return (
                                        <CheckBox
                                            key={option.value}
                                            label={option.label}
                                            checked={selecionado}
                                            onChange={() => this.handleCheckboxChange(option.value)}
                                            disabled={disabled}
                                        />
                                    );
                                })}
                            </FormGroup>

                            {this.state.helpers.anosLetivos && (
                                <span style={{ color: 'red', fontSize: 12 }}>
                                    {this.state.helpers.anosLetivos}
                                </span>
                            )}

                        </FormControl>
                    </Grid>
                </Grid>
            </>
        )
    }
}

export default AnosLetivos;